<template>
  <div class="cf-text-input cf-text-input--small cf-text-input--no-label cf-text-input--has-icon">
    <button
      v-if="modelValue"
      class="cf-text-input__overlay-button"
      type="button"
      title="Reset Search"
      tabindex="-1"
      @click="reset"
    >
      <span class="cf-icon cf-icon--black fal fa-times" />
    </button>

    <input
      ref="input"
      class="cf-text-input__input"
      type="search"
      :placeholder="placeholder"
      :value="modelValue"
      @focus="focusHandler"
      @input="inputHandler"
    >

    <div
      class="cf-text-input__icon"
      aria-hidden="true"
    >
      <span class="cf-icon cf-icon--black far fa-search" />
    </div>
  </div>
</template>


<script>
  import debounce from 'debounce';


  export default {
    name: 'SearchInput',

    props: {
      placeholder: {
        type: String,
        default: 'Search...'
      },

      modelValue: {
        type: String,
        default: ''
      }
    },

    methods: {
      focus() {
        this.$refs.input.focus();
      },

      focusHandler() {
        window.scrollTo(0, 0);

        this.$emit('search-focus');
      },

      inputHandler(event) {
        window.scrollTo(0, 0);

        this.setValue(event.target.value);
      },

      setValue: debounce(function setValue(value) {
        this.$emit('update:modelValue', value);
      }, 250),

      reset() {
        this.$refs.input.focus();


        this.$emit('update:modelValue', '');
      }
    }
  };
</script>
